import styled from 'styled-components';
import TeamQuizGraphComponent from 'challenge/common/TeamQuizGraph';
import LoggedActivitiesCardComponent from 'challenge/common/LoggedActivitiesCard';
import NewQuizComponent from 'challenge/common/NewQuiz';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px 16px 16px;
  height: calc(100vh - 122px);
  overflow: auto;
  flex-grow: 1;
`;

export const ColumnsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 296px;
  justify-content: flex-start;
  align-items: center;
`;

export const TeamQuizGraph = styled(TeamQuizGraphComponent)`
  margin-bottom: 40px;
`;
export const LoggedActivitiesCard = styled(LoggedActivitiesCardComponent)``;
export const NewQuiz = styled(NewQuizComponent)``;
